module.exports = __webpack_public_path__ + "static/media/10.7c4db8c4.jpg";